import React, { useState } from "react";
import * as Mui from "@mui/material";
import { themes, reportNames } from "services/constants";
import { WorkingHours } from "./WorkingHours";
import AnomaliesReport from "./Anomalies";
import DailyReport from "./DailyReport";
import OvertimeReport from "./OvertimeReport";
import LateCountReport from "./CountReport";
import { formBackGroundColor } from "services/constants/Styles";
import { LeaveAndPermission } from "./LeaveAndPermission";

export const Reports = () => {
  const [reportName, setReportName] = useState("Summarized working hours");
  const [showReports, setShowReport] = useState(false);
  const [overTimeReportScreen, setOverTimeReportScreen] = useState(false);

  return (
    <React.Fragment>
      {!showReports ? (
        <Mui.Grid
          container
          sx={{
            paddingTop: "3%",
            paddingLeft: "6%",
            paddingRight: "6%",
            paddingBottom: "5%",
          }}
        >
          <Mui.Grid
            container
            xs={12}
            sx={{
              border: `2px solid ${themes.sidebarDivider}`,
              borderRadius: "10px 10px 10px 10px",
            }}
          >
            <Mui.Grid
              xs={12}
              sx={{
                backgroundColor: formBackGroundColor,
                padding: {
                  xs: 0.5,
                  sm: 0.5,
                  md: 0.5,
                  lg: 0.5,
                  xl: 1,
                },
                textAlign: "left",
                borderBottom: `2px solid ${themes.sidebarDivider}`,
              }}
            >
              <Mui.Typography
                sx={{ fontSize: 22, fontWeight: 700, paddingLeft: 3 }}
              >
                Report Name
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingLeft: "1%", paddingRight: "1%" }}>
              {reportNames?.map((name, index) => (
                <Mui.Tooltip
                  title={"Open"}
                  placement="bottom-start"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        ml: 6,
                        color: themes.whiteColor,
                        fontSize: "14px",
                        backgroundColor: themes.darkBlue,
                        borderRadius: "10px",
                      },
                    },
                  }}
                  key={index}
                >
                  <Mui.Grid
                    container
                    sx={{
                      border: `1px solid ${themes.sidebarDivider}`,
                      padding: 1,
                      mt: 1,
                      borderRadius: 2,
                      mb: 1,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowReport(true);
                      setReportName(name.label);
                      setOverTimeReportScreen(true);
                    }}
                  >
                    <Mui.Typography sx={{ paddingLeft: 2, fontWeight: 650 }}>
                      {name.label}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Tooltip>
              ))}
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      ) : reportName !== "Attendance Anomalies Report" &&
        reportName !== "Daily Report" &&
        reportName !== "Overtime Report" &&
        reportName !== "Late Report" &&
        reportName !== "Leave and Permission Reports" ? (
        <WorkingHours setShowReport={setShowReport} reportName={reportName} />
      ) : reportName === "Attendance Anomalies Report" ? (
        <AnomaliesReport setShowReport={setShowReport} />
      ) : reportName === "Daily Report" ? (
        <DailyReport setShowReport={setShowReport} />
      ) : reportName === "Overtime Report" ? (
        <OvertimeReport
          setShowReport={setShowReport}
          overTimeReportScreen={overTimeReportScreen}
          setOverTimeReportScreen={setOverTimeReportScreen}
        />
      ) : reportName === "Late Report" ? (
        <LateCountReport setShowReport={setShowReport} />
      ) : reportName === "Leave and Permission Reports" ? (
        <LeaveAndPermission setShowReport={setShowReport} />
      ) : null}
    </React.Fragment>
  );
};
